import React from "react";
import Instagram from "../utils/socialIcons/Instagram";
import Facebook from "../utils/socialIcons/Facebook";
import LinkedIn from "../utils/socialIcons/LinkedIn";
import GitHub from "../utils/socialIcons/GitHub";

import "../css/logo-btn.css";
import "../css/my-name.css";

export default function Footer() {
  const footerText = process.env.REACT_APP_FOOTER_TEXT || "FAREWELLLL!";

  return (
    <>
      <div className="footer-container">
        <div className="border bottom-side"></div>

        <footer className="footer" id="contact">
          <div className="container footer--grid footer--grid--2-cols">
            <div className="logo-col">
              <div className="footer--logo-btn">
                <a className="btn btn-two" href="/#">
                  <span className="logo-text">{footerText}</span>
                </a>
              </div>

              <ul className="social-links">
                <li>
                  {/* https://www.instagram.com/jayanttarora */}
                  <a
                    className="footer-link"
                    href="https://www.instagram.com/jayanttarora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Instagram className="social-icon" />
                  </a>
                </li>

                <li>
                  <a
                    className="footer-link"
                    href="https://www.facebook.com/jayanttarora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Facebook className="social-icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="footer-link"
                    href="https://www.linkedin.com/in/jayantarora63"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedIn className="social-icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="footer-link"
                    href="https://github.com/jayanttArora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <GitHub className="social-icon" />
                  </a>
                </li>
              </ul>

              {/* <p className="copyright">
            Copyright &copy; <span className="year">2027</span> by Omnifood, Inc.
            All rights reserved.
          </p> */}
            </div>
            <div className="address-col">
              <p className="footer-heading">Want to connect?</p>
              <address className="contacts">
                <p className="address">Let&rsquo;s do it</p>
                <p className="contact-dtls">
                  <a className="footer-link" href="tel:+91-8630763261">
                    +91-8630763261
                  </a>
                  <br />
                  <a
                    className="footer-link"
                    href="mailto:jayantarora63@gmail.com"
                  >
                    jayantarora63@gmail.com
                  </a>
                </p>
              </address>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
